/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S8_C_Li3Inputs */

const tr_mesafeli_s8_c_li3 = /** @type {(inputs: Mesafeli_S8_C_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesap giriş bilgilerinin gizliliğinden sorumlu olmak; bu bilgilerle yapılan işlemler Müşteri adına yapılmış sayılır.`)
};

const en_mesafeli_s8_c_li3 = /** @type {(inputs: Mesafeli_S8_C_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To be responsible for the confidentiality of the account login data; transactions carried out with this data are deemed to have been carried out on behalf of the Customer.`)
};

const de_mesafeli_s8_c_li3 = /** @type {(inputs: Mesafeli_S8_C_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für die Vertraulichkeit der Zugangsdaten des Kontos verantwortlich sein; mit diesen Daten vorgenommene Vorgänge gelten als im Namen des Kunden vorgenommen.`)
};

const ru_mesafeli_s8_c_li3 = /** @type {(inputs: Mesafeli_S8_C_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отвечать за конфиденциальность данных для входа в аккаунт; операции, совершённые с использованием этих данных, считаются совершёнными от имени Клиента.`)
};

/**
* | output |
* | --- |
* | "To be responsible for the confidentiality of the account login data; transactions carried out with this data are deemed to have been carried out on behalf of..." |
*
* @param {Mesafeli_S8_C_Li3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s8_c_li3 = /** @type {((inputs?: Mesafeli_S8_C_Li3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S8_C_Li3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s8_c_li3(inputs)
	if (locale === "de") return de_mesafeli_s8_c_li3(inputs)
	if (locale === "ru") return ru_mesafeli_s8_c_li3(inputs)
	return tr_mesafeli_s8_c_li3(inputs)
});